// Day 5 — Chart Linking + Manual Review API client
// All endpoints gated server-side by clinical_chart_review_enabled + participant_charts.edit.
import api from '@/lib/api';

export async function linkCarePlan(participantId, chartId, carePlanId) {
  const res = await api.put(
    `/participants/${participantId}/charts/${chartId}/link-care-plan`,
    { care_plan_id: carePlanId },
  );
  return res.data?.data;
}

export async function unlinkCarePlan(participantId, chartId) {
  const res = await api.put(`/participants/${participantId}/charts/${chartId}/unlink-care-plan`);
  return res.data?.data;
}

export async function linkGoal(participantId, chartId, goalId) {
  const res = await api.put(
    `/participants/${participantId}/charts/${chartId}/link-goal`,
    { goal_id: goalId },
  );
  return res.data?.data;
}

export async function unlinkGoal(participantId, chartId) {
  const res = await api.put(`/participants/${participantId}/charts/${chartId}/unlink-goal`);
  return res.data?.data;
}

export async function markForReview(participantId, chartId, reviewNote) {
  const res = await api.put(
    `/participants/${participantId}/charts/${chartId}/mark-review`,
    { review_note: reviewNote || '' },
  );
  return res.data?.data;
}

export async function clearReview(participantId, chartId) {
  const res = await api.put(`/participants/${participantId}/charts/${chartId}/clear-review`);
  return res.data?.data;
}

export async function completeReview(participantId, chartId, outcomeNote) {
  const res = await api.put(
    `/participants/${participantId}/charts/${chartId}/complete-review`,
    { review_outcome_note: outcomeNote || '' },
  );
  return res.data?.data;
}

// ── Lookups used by link modals ───────────────────────────────────
// Existing endpoints. We tolerate envelope shapes: {items}, {data:{items}}, {data:[]}.
function _flatten(res) {
  const payload = res?.data ?? res;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.items)) return payload.data.items;
  return [];
}

export async function listCarePlansForParticipant(participantId) {
  try {
    const res = await api.get(`/careplans/by-participant/${participantId}`, { params: { limit: 100 } });
    return _flatten(res);
  } catch {
    return [];
  }
}

export async function listGoalsForParticipant(participantId) {
  try {
    const res = await api.get(`/goals/by-participant/${participantId}`, { params: { limit: 100 } });
    return _flatten(res);
  } catch {
    return [];
  }
}
